import { render, staticRenderFns } from "./unicomDeal4.vue?vue&type=template&id=43dbd2ee&scoped=true"
import script from "./unicomDeal4.vue?vue&type=script&lang=js"
export * from "./unicomDeal4.vue?vue&type=script&lang=js"
import style0 from "./unicomDeal4.vue?vue&type=style&index=0&id=43dbd2ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43dbd2ee",
  null
  
)

export default component.exports